import gql from "graphql-tag";

export default {
  update: gql`
    mutation UpdateJackpotCell ($input: UpdateJackpotCellInput!) {
      updateJackpotCell (input: $input) {
        id
        cell_type
        box_uri
        lam_uri
        box_left
        box_top
        box_width
        box_height
      }
    }`,

  get: gql`
    query JackpotCell($id: ID!) {
      jackpotCell(id: $id) {
        id
        cell_type
        box_uri
        lam_uri
        box_left
        box_top
        box_width
        box_height
        game{
          id
          prizes{
            id
            slot_index
          }
        }
        fields {
          id
          type
          name
          label
          required
          sort_order
          half_width
          visible
          options{
            id
            form_field_id
            name
            label
            i18n{
              language_code
              label
            }
          }
          i18n {
            language_code
            label
          }
        }
      }
    }`
}
